export const LOCALHOST = 'localhost';

export const DEV_HOST_IDENTIFIER = 'client-dashboard-dev.agileengine.com';
export const PROD_HOST_IDENTIFIER = 'client-dashboard.agileengine.com';

export const is = {
  localhost:
    window.location.hostname.includes(LOCALHOST) ||
    window.location.hostname.startsWith('127.') ||
    window.location.hostname.startsWith('10.') ||
    window.location.hostname.startsWith('172.') ||
    window.location.hostname.startsWith('192.'),
  dev: window.location.hostname.includes(DEV_HOST_IDENTIFIER),
  prod: window.location.hostname.includes(PROD_HOST_IDENTIFIER),
};

export function isEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export function isValidDate(date: Date): boolean {
  return String(date) !== 'Invalid Date';
}
